import React from "react";

const LoadingSpinner = () => (
  <div
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background: "#fff",
      zIndex: 999,
    }}
  >
    <div
      style={{
        width: 120,
        height: 3,
        background: "#f0f0f0",
        borderRadius: 3,
        overflow: "hidden",
      }}
    >
      <div
        style={{
          width: "50%",
          height: "100%",
          background: "#ff6b35",
          borderRadius: 3,
          animation: "ld-bar 1.4s ease-in-out infinite",
        }}
      />
    </div>
    <style>{`
      @keyframes ld-bar {
        0% { transform: translateX(-100%); }
        50% { transform: translateX(0%); }
        100% { transform: translateX(100%); }
      }
    `}</style>
  </div>
);

export default LoadingSpinner;
